import React from "react";

/** Bid history list (logged-in users). */
export default function BidHistory({
  LotStatus,
  accountID,
  bidHistory,
  bidderCount,
  current,
  group,
  isWidraw,
  token,
  userBidder,
}) {
  return (
    <>
      {token !== null && isWidraw !== 1 && bidHistory.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <p
            style={{
              fontSize: "11px",
              fontWeight: 800,
              color: "#000",
              marginBottom: "8px",
              textTransform: "uppercase",
            }}
          >
            BID HISTORY ({bidderCount})
          </p>
          <div
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              padding: "10px",
              borderRadius: "4px",
            }}
          >
            <table style={{ width: "100%", fontSize: "13px" }}>
              <tbody>
                {(() => {
                  const highestBid = Math.max(
                    ...bidHistory.map((val) =>
                      group === "ADMIN"
                        ? parseInt(val.amount)
                        : parseInt(val.myBidAmount)
                    )
                  );
                  return bidHistory.map((val, i) => {
                    const amount =
                      group === "ADMIN"
                        ? val.amount
                        : val.myBidAmount;
                    const parsedAmount = parseInt(amount);
                    const isCurrent =
                      parsedAmount === parseInt(current) &&
                      userBidder === accountID;
                    const isHighest =
                      parsedAmount === highestBid &&
                      userBidder === accountID;
                    const color =
                      isCurrent || isHighest ? "green" : "red";
                    const StatusBid =
                      LotStatus === "SOLD" && (isCurrent || isHighest)
                        ? "Win"
                        : isCurrent || isHighest
                        ? "Winning"
                        : "Outbid";
                    return (
                      <tr
                        key={i}
                        style={{ borderBottom: "1px solid #f9f9f9" }}
                      >
                        <td style={{ padding: "6px 0" }}>
                          <span
                            style={{
                              color: color,
                              fontWeight:
                                isCurrent || isHighest ? 700 : 400,
                            }}
                          >
                            {group === "ADMIN"
                              ? val.email
                              : StatusBid}
                          </span>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <span
                            style={{ color: color, fontWeight: 700 }}
                          >
                            ₱{" "}
                            {amount != null
                              ? parsedAmount.toLocaleString()
                              : "0"}
                          </span>
                        </td>
                      </tr>
                    );
                  });
                })()}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
